import { useParams } from 'react-router-dom';
import { SubPageLayout } from '../../../../sub-page-layout';
import { CaseDetailsApplicationContainer } from '../components/case-details-application.container.tsx';
import { getItem } from '../../../../../../../shared/local-storage.ts';
import { Helmet } from 'react-helmet';

export const ApplicationCredCase: React.FC = () => {
  const params = useParams();
  const applicantUserId = getItem('applicantUserId');
  return (
    <div style={{ marginTop: '25px' }}>
      <Helmet>
        <title>Case - Application</title>
      </Helmet>
      <SubPageLayout title="Credential Verification Request">
        <CaseDetailsApplicationContainer applicantId={applicantUserId ?? ''} caseId={params['caseId'] ?? ''} />
      </SubPageLayout>
    </div>
  );
};
